import React, { FC, useState, useEffect } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { ICustomerProps, Customer } from 'apps/fleet-planner/components/form-components/Customer'
import { useCreateLoadFormContext } from 'apps/fleet-planner/context'
import { ILoad } from 'apps/fleet-planner/types'

type IBaseControllerProps = ControllerProps<React.ComponentType<ICustomerProps>>
export interface IControlledCustomerProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  CustomerProps?: Partial<ICustomerProps>
}
/**
 * Helper component for use with React Hook Form
 * @see https://react-hook-form.com/api#Controller
 * @example
 * ```
 * <ControlledCustomer
 *   name='pickupNumber'
 *   control={control}
 *   CustomerProps={{
 *     label: 'Pickup Number',
 *     placeholder: '1234',
 *   }}
 * />
 * ```
 */
export const ControlledCustomer: FC<IControlledCustomerProps> = ({ CustomerProps = {} }) => {
  const { large = true } = CustomerProps || {}
  const { control, setValue } = useCreateLoadFormContext()
  const [load, setLoad] = useState<Pick<ILoad, 'customer' | 'customerNotes' | 'customerContact'>>(
    {}
  )
  const changeHandler = (change: Partial<ILoad>) => {
    setLoad(prev => ({
      ...prev,
      ...change,
    }))
  }
  const { customer, customerContact, customerNotes } = load || {}

  useEffect(() => {
    if (customer?.id) {
      setValue('customer', { id: customer?.id })
    }
  }, [customer, setValue])

  useEffect(() => {
    setValue('customerNotes', customerNotes || '')
  }, [customerNotes, setValue])

  useEffect(() => {
    if (customerContact?.id) {
      setValue('customerContact', { id: customerContact?.id })
    }
  }, [customerContact, setValue])
  return (
    <>
      <Controller
        name='customer'
        control={control}
        defaultValue={{}}
        render={({ value }) => <input type='hidden' value={value} />}
      />
      <Controller
        name='customerContact'
        control={control}
        defaultValue={{}}
        render={({ value }) => <input type='hidden' value={value} />}
      />
      <Controller
        name='customerNotes'
        control={control}
        defaultValue=''
        render={({ value }) => <input type='hidden' value={value} />}
      />
      <Customer
        onChange={changeHandler}
        customer={customer}
        customerNotes={customerNotes}
        customerContact={customerContact}
        large={large}
      />
    </>
  )
}
